<template>
  <div class="ac200-alarm-flag">
    <img :src="img" />
  </div>
</template>

<script>
export default {
  props: {
    state: {
      type: Number,
      default: 0
    }
  },
  computed: {
    img() {
      return require(`@/assets/image/device/ac200/l${this.state + 1}.png`);
    }
  }
};
</script>

<style lang="scss" scoped>
.ac200-alarm-flag {
  img {
    width: 11.75em;
    height: 7.1875em;
  }
}
</style>
